const $ = require("jquery");

class ResourcesGrid {
	constructor (uuid) {
		$(document).on("verticalChanged", (e, verticalSlug) => {
			const feed = $(`#${uuid} .cs-resources-card-container`)
				.data("feed");

			switch (feed) {
				case "vertical":
				case "related": {
					$(`#${uuid} .cs-resources-card-container`).addClass("hide");
					$(`#${uuid} [data-verticals*=${verticalSlug}]`)
					.removeClass("hide");
					break;
				}
			}

			// Refresh the grid
			$(`#${uuid} .cs-resources-card-container`).each(function () {
				$(this).find('.cs-resources-circle').each(function () {
					$(this).css({
						width: `${$(this).height()}px`,
						left: `${-$(this).height()}px`
					});
				});
			});
		});

		$(`#${uuid} .cs-resources-card-container`).each(function () {
			$(this).find('.cs-resources-circle').each(function () {
				$(this).css({
					width: `${$(this).height()}px`,
					left: `${-$(this).height()}px`
				});
			});

			$(this).find('.cs-resources-play-btn').each(function () {
				const playBtnWidth = $(this).closest('.cs-resources-circle').height() / 6
				$(this).css({
					'border-top': `${playBtnWidth / 2}px solid transparent`,
					'border-left': `${playBtnWidth}px solid white`,
					'border-bottom': `${playBtnWidth / 2}px solid transparent`,
					'margin-left': `${$('.cs-resources-circle').height() / 2 / 2 - playBtnWidth / 2 / 2}px`
				});
			});

			$(this).find('.cs-resources-overlay').each(function () {
				$(this).css({ 'left': `calc(100% + ${$(this).find('.cs-resources-circle').height() / 2}px)` })
			});

			$(this).on('mouseenter', function () {
				$(this).find('.cs-resources-overlay').css({ 'left': 0 })
			});

			$(this).on('mouseleave', function () {
				$(this)
					.find('.cs-resources-overlay')
					.css({
						'left': `calc(100% + ${$(this).find('.cs-resources-circle').height() / 2}px)`
					});
			});
		});
	}
}

$(document).ready(() => {
	$(".itbl-b-resources-grid").each((i, e) => {
		new ResourcesGrid($(e).attr("id"));
	});
});
